
import jobProcessor from './job';

export default {
    job: {
        shouldProcess(data) {
            return 'job' in data;
        },
        process: jobProcessor
    }
}